/*

Joii V3: JavaScript Basket

*/
window.cartURLran = false;

var userCart = false;
var recommendedFlickity = false;





function getCookie(name) {
  return document.cookie.split("; ").reduce((r, v) => {
  const parts = v.split("=");
  return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, null);
}


function deleteCookie(name) {
    setCookie(name, "", -1);
}

// On /cart page: check cookie and apply discount via AJAX
// if (window.location.pathname === "/cart") {
//     const pendingDiscount = getCookie("pendingDiscount");
//     if (pendingDiscount) {
//     fetch("/discount/" + pendingDiscount, {
//         method: "GET",
//         credentials: "same-origin"
//     })
//     .then(() => {
//         console.log(`Discount ${pendingDiscount} applied successfully!`);
//         deleteCookie("pendingDiscount");
//         // Optional confirmation message
//         const msg = document.createElement("div");
//         msg.textContent = "Discount applied!";
//         msg.style.position = "fixed";
//         msg.style.bottom = "20px";
//         msg.style.right = "20px";
//         msg.style.background = "#4caf50";
//         msg.style.color = "#fff";
//         msg.style.padding = "10px 15px";
//         msg.style.borderRadius = "5px";
//         msg.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
//         document.body.appendChild(msg);
//         setTimeout(() => msg.remove(), 3000);
//     })
//     .catch((err) => console.error("Error applying discount:", err));
//     }
// }
// if (window.location.pathname === "/cart") {
//   const pendingDiscount = getCookie("pendingDiscount");

//   if (pendingDiscount) {
//     deleteCookie("pendingDiscount");
//     //window.location.href = "/cart/discount/" + pendingDiscount;
//     // https://www.joiipetcare.com/discount/FIRST5?redirect=/cart
//     window.location.href = "/discount/" + pendingDiscount + "?redirect=/cart";
//   }
// }


/*
      Helpers
*/
function fetchCart() {
  //console.log(`fetchCart`);
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(cart => {
      if (userCart == false) {
        userCart = cart;
        afterFirstCartFetch();
      } else {
        userCart = cart;
      }
      //console.log("Cart Attributes:", cart.attributes);
      return cart;})
    .catch(error => {console.error("Error fetching cart attributes:", error);});
}


function addToCartSkeleton(itemGroup) {
  var cartContainer = document.querySelector(".cart-form-wrapper");
  var skelCartItem = document.createElement("div");
  skelCartItem.classList.add("cart-details-item");
  skelCartItem.classList.add("single");

  skelCartItem.innerHTML = `
    <div class="joii-special-cart-item" style="display: flex; gap: .3rem; align-items: center; flex-direction: row;">
    </div>
    <div class="cart-details-item-inner" style="padding-bottom: 10px !important;">
      <div class="cart-item-media-wrapper" style="height: 100%;">
        <a class="cart-item-media">
        <div class="media">
          <div class="joii-skel-img"></div>
        </div>
        </a>
        <div class="cart-item-details" style="height: 100%; justify-content: space-between; display: flex; flex-direction: column;">
          <div class="cart-item-details-top">
            <div class="product-title joii-skel-txt" style="width: 80%;"></div>
            <ul class="item-variant-title">
              <li>
              <div class="joiiCartVarTitle joii-skel-txt" style="width: 30%;"></div>
              </li>
            </ul>
          </div>
          <div class="cart-item-details-bottom" style="margin-top: 2rem;">
            <div class="joiiCartItemPrice" style="display: flex; gap: 10px;">
              <div class="actual-price joii-skel-txt" style="margin-bottom: .5rem; width: 20%;"></div>
            </div>
          </div>
        </div>
      </div> 
      <div class="cart-item-quantity-wrapper desktop-cart-item-quantity" data-quantity-wrapper="">
        <div class="cart-remove desktop">
          <div class="joii-skel-img" style="width: 25px; height: 25px;"></div>
        </div>
        <div class="product-quantity-inner small-quantity" style="display: flex; gap: 10px;">
          <div class="joii-skel-img" style="width: 34px; height: 34px;"></div>
          <div class="joii-skel-img" style="width: 34px; height: 34px;"></div>
          <div class="joii-skel-img" style="width: 34px; height: 34px;"></div>
        </div>
      </div> 
    </div>
  `;
  //cartContainer.appendChild(skelCartItem);

  // var pmsItems = cartContainer.querySelectorAll(".pms-item");
  // var insertBeforeNode = cartContainer.firstChild;

  // if (itemGroup == "pms") {
  //   insertBeforeNode = cartContainer.firstChild;
  // } else {
  //   if (pmsItems.length > 0) {
  //     // Insert after the last pms-item
  //     const lastPms = pmsItems[pmsItems.length - 1];
  //     insertBeforeNode = lastPms.nextSibling;
  //   } else {
  //     // Otherwise insert at the very top
  //     insertBeforeNode = cartContainer.firstChild;
  //   }
  // }
  
  // cartContainer.insertBefore(skelCartItem, insertBeforeNode);
  cartContainer.insertBefore(skelCartItem, cartContainer.firstChild);
  return skelCartItem;
}

function addToCart2(varId, qty, source = null) {
  //console.log("addToCart2");
  if (qty < 1) {qty = 1;}

  let section = document.querySelector("[data-cart-wrapper]");
  var sectionId = section.dataset.section;

  const payload = {
    id: varId,
    quantity: qty
  };
  //console.log(payload);

  var skelCartItem = addToCartSkeleton();

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return response.json();
  })
  .then(cart => {
    console.log("Product added to cart successfully:", cart);
    //location.reload(); // Reload the page
    //addToCartElem(); // reload item
    addToCartItems(skelCartItem); // reload all items

    // const cart = JSON.parse(state);
    // if (cart.status) {
    //   console.log(cart.message);
    //   return false;
    // }


    // userCart = cart;
    // if (cart.sections) {
    //   console.log("cart sections");
    //   console.log(cart.sections);
    //   cartContentUpdate(cart, sectionId);
    // }
    // cartNoteDrawerInt(section);
  })
  .catch(error => {
    console.error('Error adding product to cart:', error);
  });
}

function addToCartElem() {
  fetch('/cart')
  .then(res => res.text())
  .then(htmlString  => {
    const parser = new DOMParser();
    const latestCartDoc = parser.parseFromString(htmlString, 'text/html');
    var cartFormWrapper = document.querySelector(`.cart-form-wrapper`);
    var newItem = latestCartDoc.querySelector(`.cart-form-wrapper .cart-details-item`);

    // update gauge
    // var offerLabelCont = newItem.querySelector('.joii-offer-label-cont');
    // var docOfferLabelCont = newItem.querySelector('.joii-offer-label-cont');
    
    // Prepare toggles
    renumberCartItems(cartFormWrapper);
    addToggleListeners(newItem);
    // Preload img then insert
    var imgEl = newItem.querySelector('.media img');
    preloadImage(imgEl, function () {
      cartFormWrapper.insertBefore(newItem, cartFormWrapper.firstChild);
    });
    //cartFormWrapper.insertBefore(newItem, cartFormWrapper.firstChild);
  });
}


function addToCartItems(skelCartItem) {
  console.log("addToCartItems");
  fetch('/cart')
  .then(res => res.text())
  .then(htmlString  => {
    const parser = new DOMParser();
    const latestCartDoc = parser.parseFromString(htmlString, 'text/html');
    var cartFormWrapper = document.querySelector(`.cart-form-wrapper`);
    var newCartWrapper = latestCartDoc.querySelector(`.cart-form-wrapper`);

    // update gauge
    // var offerLabelCont = newItem.querySelector('.joii-offer-label-cont');
    // var docOfferLabelCont = newItem.querySelector('.joii-offer-label-cont');
    
    // Prepare toggles
    // const newItems = newCartWrapper.querySelectorAll('.cart-details-item');
    // const oldItems = cartFormWrapper.querySelectorAll(`.cart-details-item`);
    // newItems.forEach((nIt, i) => {
    //   addToggleListeners(nIt);
    //   console.log(nIt);
    //   //cartFormWrapper.insertBefore(nIt, cartFormWrapper.firstChild);
    //   cartFormWrapper.appendChild(nIt);
    // });
    // oldItems.forEach((oIt, i) => {
    //   oIt.remove();
    // });

    cartUpdateElems(document,latestCartDoc);
    // Preload img then insert
    //const imgs = newCartWrapper.querySelectorAll('img');
    //console.log(imgs);

    // Wait until they are loaded before replacing
    // waitForImages(imgs).then(() => {
    //   cartFormWrapper.innerHTML = newCartWrapper.innerHTML;
    //   renumberCartItems(cartFormWrapper);
    // });

    //cartFormWrapper.innerHTML = newCartWrapper.innerHTML;
    renumberCartItems(cartFormWrapper);
    //skelCartItem.remove();
  });
}

function waitForImages(images) {
  return Promise.all(
    Array.from(images).map(img => {
      return new Promise(resolve => {
        if (img.complete && img.naturalHeight !== 0) {
          // Already loaded
          resolve();
        } else {
          img.onload = () => resolve();
          img.onerror = () => resolve(); // Resolve anyway if it fails
        }
      });
    })
  );
}

function preloadImage(imgEl, callback) {
  var src    = imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || '';
  var srcset = imgEl.getAttribute('srcset') || imgEl.getAttribute('data-srcset') || '';
  var sizes  = imgEl.getAttribute('sizes') || '';

  var probe = new Image();
  if (srcset) probe.srcset = srcset;
  if (sizes)  probe.sizes  = sizes;
  if (src)    probe.src    = src;

  if (probe.complete) {
    callback();
  } else {
    probe.onload = callback;
    probe.onerror = callback; // proceed even if it fails
  }
}

function renumberCartItems(wrapper) {
  // direct children only
  // const items = Array.from(wrapper.querySelectorAll(':scope > .cart-details-item'));
  // const total = items.length;

  // items.forEach((el, i) => {
  //   const oneBased = i + 1;
  //   el.setAttribute('line-item-index', oneBased);
  //   el.setAttribute('data-item-id', oneBased);
  //   el.style.zIndex = String(total - i); // start at total, decrement by 1

  //   var qtyInput = el.querySelector(".quantity-input");
  //   qtyInput.setAttribute("data-line",oneBased);

  //   // var itemAccH = el.querySelector(`.accordion__header`);
  //   // itemAccH.setAttribute('data-toggle', `#joii-cart-item_${oneBased}`);
  //   // var itemAccC = el.querySelector(`.accordion__content`);
  //   // itemAccC.setAttribute('id', `joii-cart-item_${oneBased}`);
  // });
}


function addToggleListeners(newItem) {

  // Wishlist
  // var wishBtn = newItem.querySelector('.joiiSaveItem');
  // wishBtn.addEventListener("click", function() {
  //   var wishTrig = wishBtn.querySelector('.wishlist-engine[data-api-called]');
  //   var wishVarId = wishTrig.getAttribute('data-variant-id');
  //   if (wishTrig.getAttribute("data-added") == "false") {
  //     wishTrig.click();
  //     waitForElement(`.wishlist-engine[data-variant-id="${wishVarId}"][data-added="true"]`, (updatedWish) => {
  //       updatedWish.closest('.cart-details-item').remove();
  //       var cartFormWrapper = document.querySelector(`.cart-form-wrapper`);
  //       renumberCartItems(cartFormWrapper);
  //     });
  //   } else {
  //     updatedWish.closest('.cart-details-item').remove();
  //     var cartFormWrapper = document.querySelector(`.cart-form-wrapper`);
  //     renumberCartItems(cartFormWrapper);
  //   }
  // });

  
  // Quantity
  let quantityElements = newItem.querySelectorAll("[data-quantity-wrapper]");
  Array.from(quantityElements).forEach(function (element) {
    initQuantityAction(element);
    
  });
  // Remove
  let cartItemRemoveElements = newItem.querySelectorAll("[data-item-remove]");
  Array.from(cartItemRemoveElements).forEach(function (element) {
    initCartItemRemove(element);
    if (element) {
      cartTotalprice();
    }
  });

  //
  const togglers = newItem.querySelectorAll('[data-toggle]');

  // Toggle product options
  newItem.querySelectorAll(".dropdownOptions").forEach(function(dropdownOptions) {
    dropdownOptions.classList.remove("show");
  });
  newItem.querySelectorAll(".customDropdown").forEach(function(dropdown) {
    dropdown.addEventListener("click", function() {
      let productId = dropdown.getAttribute("data-id");
      let optionsDiv = document.getElementById("dropdownOptions_" + productId);

      if (optionsDiv) {
        optionsDiv.classList.toggle("show");
        console.log("Dropdown clicked, Toggling for Product ID:", productId);
        var parAccordion = this.closest('.accordion__content');
        
      }
      if (parAccordion.classList.contains('active')) {
        //parAccordion.classList.remove('active');
      } else {
        parAccordion.classList.add('active');
      }
      
    });
  });

  // Handle selection of dropdown option
  newItem.querySelectorAll(".dropdownOption").forEach(function(option) {
    option.addEventListener("click", function(event) {
      event.stopPropagation(); // Prevent dropdown from closing immediately

      // Define productId here from the clicked option
      let productId = option.getAttribute("data-product-id");
      let newValueId = option.getAttribute("data-value");
      let oldValueId = option.getAttribute("data-old-value");
      let valueText = option.innerText;
      let cartDetailsItem = event.target.closest('.cart-details-item');
      let quantityInput = cartDetailsItem.querySelector('.quantity-input').getAttribute('value');

      console.log(`Option clicked for Product ID: ${productId}, New Value ID: ${newValueId}`);

      // Update the cart with the new value.id
      updateCartVariant(productId, newValueId, oldValueId, quantityInput, cartDetailsItem.getAttribute('data-item-id'));

      // Update selected value display
      let selectedValueDiv = newItem.getElementById("selectedValue_" + productId);
      if (selectedValueDiv) {
        selectedValueDiv.innerText = valueText;
      }

      // Hide the dropdown
      let dropdownOptions = newItem.getElementById("dropdownOptions_" + productId);
      if (dropdownOptions) {
        dropdownOptions.classList.remove("show");
      }
    });
  });

  var joiiToggleSub = newItem.querySelectorAll('.joii_toggle_subscription');
  var checkPlan = newItem.querySelector('input[name="selling_plan"]');
  var prodWrap = newItem.querySelectorAll('.cart-details-item');
  var toggleButtons = newItem.querySelectorAll('.joii-selling-plan-toggle-dropdown-btn');
  var sellPlanOptions = newItem.querySelectorAll('.joii-selling-plan-options');
  var planOptions = newItem.querySelectorAll('.joii-selling-plan-option-box');
  var subDropdowns = newItem.querySelectorAll('.selling-plan-dropdown-container');

  joiiToggleSub.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const variantId = this.getAttribute('data-variant-id');
      var cartDetailsItem = toggle.closest('.cart-details-item');
      const sellingPlanDropdownContainer = cartDetailsItem.querySelector('#sellingPlanDropdownContainer_' + variantId);
      const sellingPlanInputs = newItem.querySelectorAll('input[name="selling_plan"]');
      var itemKey = cartDetailsItem.getAttribute('data-item-id');
      var currentSellingPlanId = cartDetailsItem.getAttribute('data-cur-selling-plan');
      var newSellingPlanId = toggle.getAttribute('data-plan-id');
      let quantityInput = cartDetailsItem.querySelector('.quantity-input').getAttribute('value');
      
      var itemJoiiToggleSub = toggle.closest('.cart-details-item');

      joiiToggleSub.forEach((element) => {
        if (element.getAttribute('data-variant-id') == variantId) {
          if (element == toggle) {
            element.classList.add('active');
          } else {
            element.classList.remove('active');
          }
        }
          
      });
      
      // if (toggle.classList.contains('joii_toggle_sub_one')) {
      //   itemJoiiToggleSub.classList.add('single');
      //   itemJoiiToggleSub.classList.remove('sub');
      //   newSellingPlanId = null;
      //   changeCartSellingPlan(itemKey, currentSellingPlanId, newSellingPlanId, quantityInput);
      // } else {
      //   itemJoiiToggleSub.classList.remove('single');
      //   itemJoiiToggleSub.classList.add('sub');
      // }

      cartDetailsItem.classList.add("disabled");

      if (toggle.classList.contains('joii_toggle_sub_one')) {
        itemJoiiToggleSub.classList.remove('see_frequency');
        newSellingPlanId = null;
        changeCartSellingPlan(itemKey, currentSellingPlanId, newSellingPlanId, quantityInput);
      } else {
        var setPlan = planOptions[0].getAttribute('data-plan-id');
        // Find 1 month as default selection
        planOptions.forEach((plan) => {
          if (plan.getAttribute('data-variant-id') == variantId) {
            var planName = plan.getAttribute('data_plan_name').toLowerCase();
            if (planName == "1 months" || planName == "1 month" || planName == "monthly" || planName == "1 monthly" || planName == "every 1 month" || planName == "every 1 months") {
              setPlan = plan.getAttribute('data-plan-id');
            }
          }
        });
        console.log(`set plan ${setPlan}`);
        changeCartSellingPlan(itemKey, currentSellingPlanId, setPlan, quantityInput);
      }

      subDropdowns.forEach((drop) => {
        if (drop.getAttribute('data-variant-id') == variantId) {
          drop.style.display = 'block';
        } else {
          drop.style.display = 'none';
        }
      });

      if (this.getAttribute('data-radio-type') === 'selling_plan') {
        // Show the selling plan dropdown container when "Subscribe and Save" is selected
        if (this.classList.contains("joii_toggle_sub_one") == false) {
          sellingPlanDropdownContainer.style.display = 'block';
        }
        
        sellingPlanInputs.forEach(input => {
          input.value = sellingPlanDropdownContainer.getAttribute('value');
        });
      } else {
        // Hide the selling plan dropdown container when "One-time purchase" is selected
        if (this.classList.contains("joii_toggle_sub_one") == false) {
          sellingPlanDropdownContainer.style.display = 'none';
        } 
        sellingPlanInputs.forEach(input => {
          input.value = null;
        });
      }
      event.stopPropagation();


      cartDetailsItem.classList.remove("disabled");
    });
    
  });

  // Toggle accordion
  togglers.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const selector = e.currentTarget.dataset.toggle;
      const block = document.querySelector(`${selector}`);
      
      if (e.currentTarget.classList.contains('active')) {
        block.style.maxHeight = '';
        block.classList.remove('active');
        if (block.querySelector('.dropdownOptions')) {
          block.querySelector('.dropdownOptions').classList.remove('show');
        }
      } else {
        block.style.maxHeight = block.scrollHeight + 'px';
      }
      
      e.currentTarget.classList.toggle('active');
      e.currentTarget.parentElement.classList.toggle('active');
    });
  });

  // joii_toggle_subscription
  const joiiToggles = newItem.querySelectorAll('.joii_toggle_subscription');
  joiiToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const accordionContent = toggle.closest('.accordion__content');
      if (accordionContent) {
        setTimeout(() => {
          accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
        }, 50);
      }
    });
  });

  toggleButtons.forEach(button => {
    button.addEventListener('click', function() {
      const dropdown = button.parentNode.querySelector('.joii-selling-plan-options');
      const isVisible = dropdown.style.display === 'block';
      dropdown.style.display = isVisible ? 'none' : 'block';
      // var parAccordion = button.closest('.accordion__content');
      // if (parAccordion.classList.contains('active')) {
      //   parAccordion.classList.remove('active');
      // } else {
      //   parAccordion.classList.add('active');
      // }
      if (button.classList.contains('active')) {
        button.classList.remove('active');
      } else {
        button.classList.add('active');
      }
      event.stopPropagation();
    });
  });

  planOptions.forEach(option => {
    option.addEventListener('click', function() {
      // Mark the selected plan as active
      planOptions.forEach(opt => opt.classList.remove('active'));
      option.classList.add('active');
      option.closest('.cart-details-item').classList.add('disabled');

      // Update the button with the selected plan and price
      //const planName = option.innerText.split(' - ')[0];  // Get name without price part
      const planName = option.getAttribute('data_plan_name');
      const planDiscount = option.getAttribute('data_plan_discount');
      const planPrice = option.getAttribute('data-price');
      const variantId = option.getAttribute('data-variant-id');
      const productId = option.getAttribute('data-product-id');
      var cartDetailsItem = option.closest('.cart-details-item');
      var itemKey = cartDetailsItem.getAttribute('data-item-id');
      var currentSellingPlanId = cartDetailsItem.getAttribute('data-cur-selling-plan');
      //console.log(currentSellingPlanId);
      var newSellingPlanId = option.getAttribute('data-plan-id');
      
      let quantityInput = cartDetailsItem.querySelector('.quantity-input').getAttribute('value');
      //console.log(quantityInput);
      //const sellingPlanDropdownContainer = option.querySelector('#sellingPlanDropdownContainer_' + variantId);
      //const planButton = sellingPlanDropdownContainer.querySelector('.joii-selling-plan-toggle-dropdown-btn');
      const sellingPlanDropdownContainer = document.querySelector('#sellingPlanDropdownContainer_' + variantId);
      const planButton = sellingPlanDropdownContainer.querySelector('.joii-selling-plan-toggle-dropdown-btn');
      const sellingPlanInputs = document.querySelectorAll('input[name="selling_plan"]');

      // Update the button's label and price
      let label = planButton.querySelector('.joii-selling-plan-label');
      if (label) label.innerText = planName;
      
      let price = planButton.querySelector('.joii-selling-plan-price');
      if (price) price.innerText = planPrice;
      
      let discount = planButton.querySelector('.joii-selling-plan-discount');
      if (discount) discount.innerText = planDiscount;
      //sellingPlanDropdownContainer.value = option.getAttribute('data-plan-id');
      sellingPlanInputs.forEach(input => {
        input.value = option.getAttribute('data-plan-id');
      });
      

      // Hide the dropdown after selecting a plan
      sellingPlanDropdownContainer.querySelector('.joii-selling-plan-options').style.display = 'none';
      changeCartSellingPlan(itemKey, currentSellingPlanId, newSellingPlanId, quantityInput);
      event.stopPropagation();
    });
  });
}





document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.includes("/cart") && window.location.search) {
    if (!window.cartURLran) {
      cartURLscript();
    }
  }
});



/*
      Basket Link Handler
*/
(async function cartURLscript() {
  window.cartURLran = true;
  var itemsComplete = false;
  var sourceComplete = false;
  var baseUrl = window.location.pathname;
  if (baseUrl.indexOf("/cart") > -1) {
    fetchCart();
  }

  function getUrlParams() { // Get URL Params
    const params = new URLSearchParams(window.location.search);
    const full_doc_id = (params.get("consultation_doc_id") || "").trim();
    const full_sqp_reg = (params.get("sqp") || "").trim();
    const clean_doc_id = full_doc_id.split("&")[0];
    const clean_sqp_reg = full_sqp_reg.split("&")[0];
    
    //console.log(clean_doc_id);
    return {
      cons_doc_id: clean_doc_id,
      sqp_reg_number: clean_sqp_reg,
      items: params.get("items"),
      nfas: params.get("nfa")
    };
  }

  function calculateDOB(nowDate, months, years) { // DOB helper
    const dob = new Date(nowDate);
    dob.setFullYear(dob.getFullYear() - years);
    dob.setMonth(dob.getMonth() - months);

    const day = String(dob.getDate()).padStart(2, '0');
    const month = String(dob.getMonth() + 1).padStart(2, '0');
    const year = dob.getFullYear();

    return `${day}/${month}/${year}`;
  }

  function parseItems(itemsString, nfaString) { // parse the items string into array of product objects
    if (!itemsString && !nfaString) return [];
    const itemResults = [];

    if (nfaString) {
      const nfaItems = nfaString.split(",").map(item => { // per nfa item
        // const nfaItems = nfaString.split("|var").map(item => { // per nfa item
        const parts = item.split("|"); // per nfa key
        if (parts.length < 2) return null;

        let properties = {
          "Vet's Note": "",
          "_PMS": "",
          "_other_medication_details": ""
        };
        var nfaVarId = "";
        var nfaQ = "";
        var ageDOB = "";
        var ageMonths = "";
        var ageYears = "";
        parts.forEach(function (part) { // foo:bar
          var nfapart = part.split(":");
          var nKey = nfapart[0];
          var nVal = nfapart[1];
          if (nKey == "id") { nfaVarId = nVal; }
          else if (nKey == "varid") { nfaVarId = nVal; }
          else if (nKey == "q") { nfaQ = nVal; }
          else if (nKey == "vn") { properties["Vet's Note"] = decodeURIComponent(nVal); }
          else if (nKey == "number") { properties["_sqp_reg_number"] = nVal; }
          else if (nKey == "name") { properties["_animal_name"] = decodeURIComponent(nVal); }
          else if (nKey == "species") { properties["_animal_species"] = decodeURIComponent(nVal); }
          else if (nKey == "dob") { ageDOB = nVal.replace(/-/g, "/"); }
          else if (nKey == "months") { ageMonths = decodeURIComponent(nVal); }
          else if (nKey == "years") { ageYears = decodeURIComponent(nVal); }
          else if (nKey == "weight") { properties["_animal_weight"] = decodeURIComponent(nVal); }
          else if (nKey == "health") {
            if (nVal == "true" || nVal == "Yes" ) { properties["_in_good_health"] = "Yes"; }
            else if (nVal == "false" || nVal == "No" ) { properties["_in_good_health"] = "No"; } }
          else if (nKey == "lactating") {
            if (nVal == "true" || nVal == "Yes" ) { properties["_pregnant_or_lactating"] = "Yes"; }
            else if (nVal == "false" || nVal == "No" ) { properties["_pregnant_or_lactating"] = "No"; } }
          else if (nKey == "medication") {
            if (nVal == "true" || nVal == "Yes" ) { properties["_on_other_medication"] = "Yes"; }
            else if (nVal == "false" || nVal == "No" ) { properties["_on_other_medication"] = "No"; } }
          else if (nKey == "details") { properties["_other_medication_details"] = decodeURIComponent(nVal); }
        });
        // Always true, checked internally:
        properties["_shopper_competent"] = "True";
        properties["_for_authorised_purpose"] = "True";
        properties["_spc_warnings_provided"] = "True";

        if (ageDOB != "") {
          //properties["_animal_dob"] = ageDOB;
          properties["_animal_dob"] = decodeURIComponent(ageDOB);
        } else {
          var curDate = new Date();
          ageDOB = calculateDOB(curDate, ageMonths, ageYears);
          properties["_animal_dob"] = ageDOB;
        }

        return {
          id: nfaVarId, // product id
          quantity: nfaQ,
          properties
        };
      }).filter(item => item !== null);
      itemResults.push(...nfaItems);
    }
    if (itemsString) {
      const normalitems = itemsString.split(",").map(item => {
        const parts = item.split(":");
        if (parts.length < 2) return null;
        if (itemResults.some(existing => existing.id === parts[0])) { // skip adding duplicate
          return null;
        }

        let properties = {
          "Vet's Note": "",
          "_PMS": ""
        };
        if (parts[2]) { properties["Vet's Note"] = decodeURIComponent(parts[2]); }
        if (parts[3]) { properties["Upload Prescription"] = decodeURIComponent(parts[3]); }

        return {
          id: parts[0],  // product id
          quantity: parseInt(parts[1], 10),
          properties
        };
      }).filter(item => item !== null);
      itemResults.push(...normalitems);
    }
    
    return itemResults;
  }

  // Function to fetch current cart items
  async function fetchCartItems() {
    try {
      const response = await fetch("/cart.js");
      const data = await response.json();
      return data.items.map(item => ({
        id: item.id,
        quantity: item.quantity,
        properties: item.properties
      }));
    } catch (error) {
      console.error("Error fetching cart items:", error);
      return [];
    }
  }

  // Function to add items to Shopify cart
  async function addToCart(items) {
    if (items.length === 0) return;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ items })
      });
      if (response.ok) {
        const data = await response.json();
        console.log("Cart updated:", data);
        //window.location.href = "/cart";  // Optional redirect after adding items
        itemsComplete = true;
      } else {
        const errorText = await response.text();
        console.error("Failed to add items to cart:", errorText);
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  }

  async function setSourceAttributes(sourceValue,landingPage,cons_doc_id, sqp_reg_number) {
    const attributes = {
      source: sourceValue,
      landing_page: landingPage
    };
    if (cons_doc_id) {
      attributes["consultation_doc_id"] = cons_doc_id;
      //console.log("doc id: ", cons_doc_id);
    }
    if (sqp_reg_number) {
      attributes["sqp_reg_number"] = sqp_reg_number;
      //console.log("sqp: ", sqp_reg_number);
    }
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes }),
      });
  
      const data = await response.json();
      //console.log('attributes:', data.attributes);
      sourceComplete = true;
    } catch (error) {
      console.error("Error updating cart source:", error);
    }

    window.history.replaceState(null, '', window.location.pathname);
  }

  // Initialize itemsToAdd as an empty array
  const itemsToAdd = [];

  // Get the URL parameters
  const { cons_doc_id, sqp_reg_number, items, nfas } = getUrlParams();
  const cartItems = await fetchCartItems();
  const urlItems = parseItems(items, nfas);
  //console.log("cart items: ", cartItems);

  // Loop through each URL item
  for (const urlItem of urlItems) {
    const cartItem = cartItems.find(cartItem => {
      // Convert urlItem.id to a number before comparing
      if (cartItem.id !== Number(urlItem.id)) return false;

      // Compare properties manually
      const cartProps = cartItem.properties || {};
      const urlProps = urlItem.properties || {};

      // Check if the number of keys match
      const cartPropsEntries = Object.entries(cartProps);
      const urlPropsEntries = Object.entries(urlProps);

      if (cartPropsEntries.length !== urlPropsEntries.length) return false;

      // Ensure all keys/values match
      return cartPropsEntries.every(([key, value]) => urlProps[key] === value);
    });

    //console.log('Checking urlItem:', urlItem);
    //console.log('Matching cartItem:', cartItem);

    // Log properties to compare
    //console.log('urlItem.properties:', JSON.stringify(urlItem.properties));
    //console.log('cartItem.properties:', JSON.stringify(cartItem ? cartItem.properties : 'No matching cart item'));

    // If the item exists in the cart
    if (cartItem) {
      // Calculate the remaining quantity needed
      if (urlItem.quantity > cartItem.quantity) {
        const remainingQuantity = urlItem.quantity - cartItem.quantity;
        //console.log('remainingQuantity:', remainingQuantity);

        // If the remaining quantity is greater than 0, add it to itemsToAdd
        if (remainingQuantity > 0) {
          itemsToAdd.push({
            id: urlItem.id,
            quantity: remainingQuantity,
            properties: urlItem.properties
          });
        }
      }
    } else {
      // If the item doesn't exist in the cart, add the full quantity to itemsToAdd
      itemsToAdd.push({
        id: urlItem.id,
        quantity: urlItem.quantity,
        properties: urlItem.properties
      });
    }
  }

  var reloadDone = false;

  function doCartReload() {
    console.log("cart reload");
    console.log("items: ", itemsComplete);
    console.log("source: ", sourceComplete);
    
    if (itemsComplete && sourceComplete && !reloadDone) {
      reloadDone = true;
      console.log("----------- reload done -------------");
      //console.log("item and source complete");
      //console.log("new href: ", window.location.href);
      //window.location.href = "/cart";
      setTimeout(() => {
        //allCartUpdate();
        window.history.replaceState(null, "", "/cart");
        history.replaceState(null, "", "/cart");
        window.location.href = "/cart";
      }, 0);
    } else {
      setTimeout(() => {
        doCartReload();
      }, 300);
    }
  }

  // If there are items to add, proceed 
  if (itemsToAdd.length > 0) { 
    console.log(`${itemsToAdd.length} items added.`);
    var cartContainer = document.querySelector(".cart-form-wrapper");
    if (cartContainer) {
      itemsToAdd.forEach(itemToAdd => {
        var skelCartItem = addToCartSkeleton();
      });
    }
    await Promise.all([ setSourceAttributes("PMS", "basket", cons_doc_id, sqp_reg_number), addToCart(itemsToAdd) ]);
    setTimeout(() => {
      doCartReload();
    }, 500);

    await setSourceAttributes("PMS", "basket", cons_doc_id, sqp_reg_number);
  } else {
    //console.log(`No new items added.`);
    itemsComplete = true;
    //window.history.replaceState(null, "", "/cart");
  }
  console.log(`Basket URL Handled`);
})();

/*
      Cosmetic
*/
var confettiInterval;
const Confettiful = function (el) {
  this.el = el;
  this.containerEl = null;
  this.confettiFrequency = 3;
  this.confettiColors = ["#fce18a", "#ff726d", "#b48def", "#f4306d"];
  this.confettiAnimations = ["slow", "medium", "fast"];
  this._setupElements();
  this._renderConfetti();
};

Confettiful.prototype._setupElements = function () {
  const containerEl = this.el.querySelector(".confetti-container");
  const elPosition = this.el.style.position;

  if (elPosition !== "relative" || elPosition !== "absolute") {
    this.el.style.position = "absolute";
  }
  this.containerEl = containerEl;
};

Confettiful.prototype._renderConfetti = function () {
  confettiInterval = setInterval(() => {
    const confettiEl = document.createElement("div");
    const confettiSize = Math.floor(Math.random() * 3) + 7 + "px";
    const confettiBackground =
      this.confettiColors[
        Math.floor(Math.random() * this.confettiColors.length)
      ];
    const confettiLeft = Math.floor(Math.random() * this.el.offsetWidth) + "px";
    const confettiAnimation =
      this.confettiAnimations[
        Math.floor(Math.random() * this.confettiAnimations.length)
      ];

    confettiEl.classList.add(
      "confetti",
      "confetti--animation-" + confettiAnimation
    );
    confettiEl.style.left = confettiLeft;
    confettiEl.style.width = confettiSize;
    confettiEl.style.height = confettiSize;
    confettiEl.style.backgroundColor = confettiBackground;

    confettiEl.removeTimeout = setTimeout(function () {
      confettiEl.parentNode.removeChild(confettiEl);
    }, 3000);

    this.containerEl.appendChild(confettiEl);
  }, 25);
};




/*
      Dynamic: All update
*/
function allCartUpdate() {
  console.log("allCartUpdate");
  updateAllGauges();
  updateCartItemOfferLabels();

  fetch('/cart')
  .then(res => res.text())
  .then(htmlString  => {
    const parser = new DOMParser();
    const newHtml = parser.parseFromString(htmlString, 'text/html');

    cartUpdateElems(document,newHtml);
    slideshowElements();

    // updateShipGauge(newHtml);
    // updateCartSummary(newHtml);

    // updateRecomProds(newHtml);

    if (document.querySelector(".cart-wrapper").getAttribute("data-item-count") != "0") {
      reloadFlickity();
    }
    var recomProdsSlider = document.querySelector('.joii-recommended-products .flickity-slider');
    var recomProds = recomProdsSlider.querySelectorAll('.product-grid-box');
    recomProds.forEach(recomProd => {
      addRecomMoveBtn(recomProd.querySelector('.joii-product-card-grid-bottom'));
    });
  });
}


/* 
      gauge  
*/

function updateShipGauge(newHtml) {
  var newShip = newHtml.querySelector('.joii-free-shipping-gauge');
  var ship = document.querySelector('.joii-free-shipping-gauge');
  ship.innerHTML = newShip.innerHTML;
}

function updateCartSummary(newHtml) {
  var newChInner = newHtml.querySelector('.cart-checkout-inner');
  var chInner = document.querySelector('.cart-checkout-inner');
  chInner.innerHTML = newChInner.innerHTML;
  var newChTerms = newHtml.querySelector('.checkoutTerms');
  var chTerms = document.querySelector('.checkoutTerms');
  chTerms.innerHTML = newChTerms.innerHTML;
}

function updateAllGauges() {
  var cartItems = document.querySelectorAll(".cart-details-item");
  //console.log(window.bundlesLoaded);
  //console.log(userCart.items);

  if (window.bundlesLoaded && userCart.items) {
    cartItems.forEach(cartIt => {
      var val = 0;
      var curBunQty = 0;
      var textVal = "";
      var bunReqQty = 0;
      var offerLblCnt = cartIt.querySelector(".joii-offer-label-cont");
      if (!offerLblCnt) {
        return;
      }
      var prodID = offerLblCnt.getAttribute('joii-id');
      var gCont = cartIt.querySelector(".gauge-container");
      var gText = cartIt.querySelector(".gauge-text");

      var qtyEl = cartIt.querySelector(".quantity-input");
      var itemQty = qtyEl.getAttribute("value");

      var bTitle = "";

      var allBundles = window.allBundles;
      allBundles.forEach(bundle => {
        bundle.products.forEach(bProdID => {
          if (prodID == bProdID) {
            bTitle = bundle.title;
          }
        });
      });

      var fallbackMsg = offerLblCnt.getAttribute("joii-deal-msg");
      var fallbackLink = offerLblCnt.getAttribute("joii-deal-url");
      if (fallbackMsg && fallbackMsg != "") {
          bTitle = fallbackMsg;
      }

      if (bTitle !== "") {
        if (bTitle.includes(" for ")) {
          let numStr = bTitle.split(" for ")[0].trim();
          numStr = numStr.match(/\d+/);
          bunReqQty = parseInt(numStr, 10);
          
          var matchingBundle = false;
          allBundles.forEach(bundle => {
            bundle.products.forEach(bProdID => {
              if (prodID == bProdID) {
                matchingBundle = true;
                curBunQty = curBunQty + itemQty;
                curBunQty = parseInt(curBunQty, 10);
              }
            });
          });

          if (!matchingBundle && fallbackLink && fallbackLink != "") {
            cartItems.forEach(checkCartIt => {
              var checkOfferLblCnt = checkCartIt.querySelector(".joii-offer-label-cont");
              var checkOfferLink = checkOfferLblCnt.getAttribute('joii-deal-url');
              if (fallbackLink == checkOfferLink) {
                var checkQtyEl = checkCartIt.querySelector(".quantity-input");
                var checkItemQty = checkQtyEl.getAttribute("value");
                curBunQty = curBunQty + checkItemQty;
              }
            });
          }
          curBunQty = parseInt(curBunQty, 10);

          if (curBunQty > bunReqQty) {
            if (!Number.isInteger(curBunQty / bunReqQty)) {
              curBunVal = curBunQty % bunReqQty;
            } else {
              curBunVal = bunReqQty;
            }
          } else {
            curBunVal = curBunQty;
          }
          if (curBunVal == bunReqQty) {
            offerLblCnt.classList.add('complete');
          } else {
            offerLblCnt.classList.remove('complete');
          }


          val = (curBunVal / bunReqQty) * 100;
          gText.textContent = `${curBunVal}/${bunReqQty}`;

          if (!isNaN(bunReqQty)) {
            //console.log(bunReqQty);
          } else {
            console.log("The part before ' for ' is not a valid integer");
          }

        }
        offerLblCnt.setAttribute("style","display: flex;");
      }

      if (val != 0) {
        if (!gCont.classList.contains('gauge-js')) {
          //console.log("_gauge start");
          startDealGauge(gCont, val, textVal);
        } else {
          gCont._gauge.setValueAnimated(val, 3);
          //console.log("_gauge set");
          //console.log(val);
          //console.log(curBunQty);
          //console.log(userCart.items);
        }
      }
    });
  } else {
    setTimeout(() => {
      updateAllGauges();
    }, 1000);
  }
}

function startDealGauge(elem, value, textVal) {
  elem._gauge = Gauge(
    elem, {
      max: 100,
      dialStartAngle: -90,
      dialEndAngle: -90.001,
      showValue: false,
      value: value,
      // label: function(value) {
      //   return textVal;
      // }
      // label: function(value) {
      //   return Math.round(value) + "/" + this.max;
      // }
      label: function(value) {
        return Math.round(value * 100) / 100;
      }
    }
  );
  elem.classList.add("gauge-js");
  //console.log("gauge created");
  //console.log(elem);
}

document.addEventListener('DOMContentLoaded', () => {
  //console.log("update gauges");
  updateAllGauges();
  setJoiiQuickAdds();
});


// (function loop() {
//   var value1 = Math.random() * 100;

//   // setValueAnimated(value, durationInSecs);
//   // var maxVals = [100, 200];
//   // elem._gauge.setMaxValue(maxVals[Math.round(Math.random())])
//   elem._gauge.setValueAnimated(value1, 1);
//   window.setTimeout(loop, 4000);
// })();


function updateRecomProds(newhtml) {
  var newRecomProds = newhtml.querySelectorAll('.joii-recommended-products .product-grid-box');
  //console.log(newRecomProds);
  var recomProdsSlider = document.querySelector('.joii-recommended-products .flickity-slider');
  var recomProds = recomProdsSlider.querySelectorAll('.product-grid-box');
  newRecomProds.forEach(newProd => {
    var nPid = newProd.getAttribute("joii-id");
    var addNewRecom = true;
    for (const prod of recomProds) {
      const pid = prod.getAttribute("joii-id");
      if (pid == nPid) {
        addNewRecom = false;
        break;
      }
    }
    if (addNewRecom == true) {
      addRecomMoveBtn(newProd.querySelector('.joii-product-card-grid-bottom'));
      recomProdsSlider.appendChild(newProd);
      //console.log(`new recom ${nPid}`);
    }
  });
}


function updateCartItemOfferLabels(attempts = 1) {
  //console.log(window.bundlesLoaded);
  if (window.bundlesLoaded && attempts < 4) {
    var allBundles = window.allBundles;
    var cartItemOfferLabelConts = document.querySelectorAll('.joii-offer-label-cont');
    if (cartItemOfferLabelConts) {
      //console.log(cartItemOfferLabelConts);
      //console.log('cartItemOfferLabelConts');
      cartItemOfferLabelConts.forEach(itemOfferCnt => {

        if (!itemOfferCnt.classList.contains('pcl')) {

          var offerLabelCont = itemOfferCnt.querySelector('.joii-offer-label');
          offerLabel = document.createElement("a");
          //console.log(itemOfferCnt.getAttribute('joii-id'));
          var hasLabel = false;

          function setOfferLabel(offerText,OfferLink,offerLabelCont) {
            offerLabel.innerHTML = `
            <svg class="icon icon-discount" viewBox="0 0 12 12" height="14" width="14" style="margin-right: 5px;">
              <path fill="#ca1b08" fill-rule="evenodd" d="M7 0h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.3.7l-6 6a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4l6-6A1 1 0 0 1 7 0m2 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0" clip-rule="evenodd"></path>
            </svg>
            <span>${offerText}</span>
            `;
            offerLabel.href = OfferLink;
            offerLabelCont.appendChild(offerLabel);
            itemOfferCnt.style.display = "flex";
            hasLabel = true;
          }

          
          allBundles.forEach(bundle => {
            bundle.products.forEach(bundProd => {

              //console.log(bundProd);
              if (itemOfferCnt.getAttribute('joii-id') == bundProd) {
                //console.log(bundProd);
                let dealName = bundle.title.includes(" on ") 
                  ? bundle.title.split(" on ")[0] 
                  : bundle.title;
                if (dealName.includes(" for ")) {
                  let numStr = dealName.split(" for ")[0].trim();
                  numStr = numStr.match(/\d+/);
                  let bunReqQty = parseInt(numStr, 10);
                  if (!isNaN(bunReqQty)) { // if has num
                    if (!isNaN(parseInt(dealName.split(" for ")[0].trim(), 10))) {
                      dealName = `Buy ${dealName}`;
                    }
                  }
                }
                setOfferLabel(dealName,bundle.link,offerLabelCont);
              }
            });
          });
          var fallbackMsg = itemOfferCnt.getAttribute("joii-deal-msg");
          var fallbackLink = itemOfferCnt.getAttribute("joii-deal-url");
          if (!hasLabel && fallbackMsg && fallbackMsg != "") {
              setOfferLabel(fallbackMsg,fallbackLink,offerLabelCont);
          }
          
          itemOfferCnt.classList.add('pcl');
        }
      });
    }
  } else {
    setTimeout(() => {
      updateCartItemOfferLabels(attempts + 1);
    }, 1000);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  var baseUrl = window.location.pathname;
  if (baseUrl.indexOf("/cart") > -1) {
    updateCartItemOfferLabels(); 
  }
});







/*
      Basket Interaction
*/
function afterFirstCartFetch() {
  var recomFetches = 1;
  var totalRecomFetches = userCart.items.length;


  //console.log(`userCart.items`);
  //console.log(userCart.items);

  function waitForElement(selector, callback) {
    let observer = new MutationObserver((mutations, obs) => {
      let element = document.querySelector(selector);
      if (element) {
        callback(element);
        obs.disconnect(); // Stop observing once found
      }
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function addRecomToCart(variantId, quantity) {
    if (quantity < 1) {
      quantity = 1;
    }
  
    // Prepare the payload
    const payload = {
      id: variantId,
      quantity: quantity
    };
  
    // Shopify's cart API to add product
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(cart => {
      console.log("Product added to cart successfully:", cart);
      //location.reload(); // Reload the page
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  
  
  // Set up the observer configuration
  var config = {
    childList: true,  // Listen for added or removed child elements
    subtree: true     // Observe changes in all descendants (not just direct children)
  };

  var recomProducts = document.querySelectorAll('.cart-wrapper .product-grid-box');
  recomProducts.forEach(function(recomProd) {
    addRecomMoveBtn(recomProd.querySelector('.joii-product-card-grid-bottom'));
  });
  //recommendedFlickitys = document.querySelectorAll('.cart-wrapper .flickity-enabled');
  if (document.querySelector(".cart-wrapper").getAttribute("data-item-count") != "0") {
      reloadFlickity();
  }
}

function reloadFlickity(flickElem) {
  // var flickityInstance = Flickity.data(flickElem);
  // if (flickityInstance) {
  //   var currentIndex = flickityInstance.selectedIndex;
  //   flickityInstance.reloadCells();
  //   flickityInstance.resize();
  //   flickityInstance.select(currentIndex, false, true);
  //   //console.log('flickity reloaded');
  // } else {
  //   var recommendedFlickitys = document.querySelectorAll('.cart-wrapper .flickity-enabled');
  //   recommendedFlickitys.forEach((recommendedFlickity) => {
  //     var flickityInstance = Flickity.data(recommendedFlickity);
  //     if (flickityInstance) {
  //       var currentIndex = flickityInstance.selectedIndex;
  //       flickityInstance.reloadCells();
  //       flickityInstance.resize();
  //       flickityInstance.select(currentIndex, false, true);
  //       //console.log('flickity reloaded');
  //     }
  //   });
  // }
}


function addRecomMoveBtn(priceElement) {
  if (priceElement.querySelector('.joii-recom-move-prod')) {
    var recomMoveProd = priceElement.querySelector('.joii-recom-move-prod');
    if (!recomMoveProd.classList.contains('js-ready')) {
      recomMoveProd.addEventListener("click", function (event) {
        addToCart2(recomMoveProd.getAttribute('joii-var-id'), 1);

        //this.closest('.product-grid-box').remove();
        //reloadFlickity(recommendedFlickity);

        var prodBox = this.closest('.product-grid-box');
        var prodCard = prodBox.querySelector('.product-card');
        prodCard.innerHTML = "";

        prodBox.style.height = "100%";
        const fullHeight = prodBox.scrollHeight + "px";
        prodBox.style.height = fullHeight;
        prodBox.style.opacity = "1";
        prodBox.style.overflow = "hidden";
        prodBox.style.transition = `height 1000ms ease, opacity 1000ms ease`;

        // Force reflow to make sure the browser registers the height
        prodBox.offsetHeight; 
        prodBox.style.height = "0px";
        prodBox.style.opacity = "0";
        setTimeout(() => {
          prodBox.remove();
          reloadFlickity();
        }, 1000);

      });
      recomMoveProd.classList.add('js-ready');
    }
  }
}


window.addEventListener("load", (event) => {
  getATCelement();
  getQuantityElement();
  getCartItemRemoveElements();
  cartGiftWrapElement();
  getEstDel();
});

function getEstDel() {
  //console.log("getEstDel");
  waitForElement(".tm-eddTable", (eddTable) => {
    setTimeout(() => {
      var trs = eddTable.querySelectorAll("tbody tr");
      let dates = [];

      trs.forEach((tr) => {
        var td = tr.querySelectorAll("td")[1];
        //console.log(`td textc: ${td.textContent}`);
        if (td && td.textContent.trim()) {
          const text = td.textContent.trim();
          if (text == "-") {
            getEstDel();
            return;
          }
          // grab the FIRST date in the range (YYYY-MM-DD)
          const m = text.match(/(\d{4}-\d{2}-\d{2})/);
          if (m) {
            //console.log(`m: ${m}`);
            dates.push(m[1]); // push full YYYY-MM-DD
          }
        }
      });

      if (dates.length === 0) {
        console.warn("No dates found in table");
        return;
      }

      const today = new Date();

      const parsedDates = dates.map((str) => {
        let d = new Date(str); // works with YYYY-MM-DD
        if (d < today) {
          d.setFullYear(d.getFullYear() + 1); // push into next year if past
        }
        return d;
      });

      if (parsedDates.length === 0) return;

      // Find soonest date
      var soonest = parsedDates.reduce((a, b) => (a < b ? a : b));

      // ✅ Add 1 day
      soonest.setDate(soonest.getDate() + 1);

      // Format output
      const weekday = soonest.toLocaleDateString("en-GB", { weekday: "long" });

      const getDaySuffix = (d) => {
        if (d > 3 && d < 21) return "th";
        switch (d % 10) {
          case 1: return "st";
          case 2: return "nd";
          case 3: return "rd";
          default: return "th";
        }
      };

      const day = soonest.getDate();
      const dayWithSuffix = `${day}${getDaySuffix(day)}`;
      const monthName = soonest.toLocaleDateString("en-GB", { month: "short" });

      const formatted = `${weekday}, ${dayWithSuffix} ${monthName}`;

      var cartEstDel = document.querySelector('.joiiCartEstDel');
      var cartEstDelText = document.querySelector('.joiiCartEstDelText');
      if (cartEstDelText) {
        cartEstDelText.innerHTML = `Estimated Delivery <strong>${formatted}</strong>.`;
        cartEstDel.setAttribute("style","display: block;")
      } else {
        getEstDel();
      }
    }, 500);
  });
}



function getATCelement(section = document) {
  let cartATCElement = section.querySelectorAll("[data-add-to-cart]");
  let cartDrawer = section.querySelector("#ajax-cart-drawer[data-side-drawer]");
  Array.from(cartATCElement).forEach(function (element) {
    initATC(element, cartDrawer);
  });
}

function initATC(element, cartDrawer) {
  element.addEventListener("click", function (event) {
    event.preventDefault();
    // Disable
    element.setAttribute("disabled", true);

    // Form
    let form = element.closest("form");
    let formParent = element.closest("[data-product-wrapper]");
    if (
      element
        .closest(".shopify-section")
        .querySelector("[data-sticky-products]")
    ) {
      // formParent
      formParent = element.closest(".shopify-section");
    }
    // if (element.closest("[data-sticky-products]")) {
    //   let formId = element.getAttribute("data-form");
    //   if (formParent.querySelector("#" + formId)) {
    //     form = formParent.querySelector("#" + formId);
    //   }
    // }

    // Reset errors
    Array.from(formParent.querySelectorAll("[data-form-error]")).forEach(
      function (errorContainer) {
        errorContainer.classList.add("hidden");
        errorContainer.textContent = "";
      }
    );
    let giftCardWrapper = formParent.querySelector("[data-gift-card-box]");
    if (giftCardWrapper) {
      let errormessageWrapper = giftCardWrapper.querySelector(
        "[data-gift-card-errors]"
      );
      let errorMessage = errormessageWrapper.querySelector(".error-message");
      errormessageWrapper.classList.add("hidden");
      errorMessage.innerHTML = "";
      // giftCardErrors
    }

    // ?
    if (element.classList.contains("bundle-product-button")) {
      formParent = element.closest("[data-product-bundle-wrapper]");
    }

    addItemtoCart(form, formParent, element, cartDrawer);
  });
}

const attributeMap = {
  "0740b518-7f33-4159-b5a3-e5df00ac4adb": "animal_name",
  "590ec18d-9756-4519-8cd7-27d4aa606b92": "species",
  "b20b0ade-de7a-4280-90ae-cb8643131260": "breed",
  "ec70a593-fec8-45c9-bc78-29a97279fa7b": "gender",
  "b9f78cb7-f6d9-4f21-93a0-5203eb5dfff9": "age",
  "2358beb2-2b59-4218-b555-75fbff60c00e": "weight",
  "a9e2846d-bc3f-48d9-991c-584a04503817": "is_animal_ill",
  "35e95423-0644-49ad-ac14-5d12f834f5e0": "health_details",
  "2f2c4fcc-3725-4ee8-b96a-70b89bef4c6b": "is_pregnant",
  "e473c65f-02e6-4457-98ef-ecdc9a7dd7b2": "pregnancy_details",
  "dc8ca006-9a03-48eb-817c-ced4030df314": "is_taking_medication",
  "70c4f466-6937-4a13-89e5-1c0bc48f3c6a": "medication_details",
  "70724fa2-b812-4643-803a-e326deb261de": "is_in_foodchain",
  "298991bc-22a8-49be-a825-f9d201b3baf3": "confirmation",
};

function updateCartInfo() {

}

function addItemtoCart(form, formParent, element, cartDrawer) {
  const config = {
    method: "POST",
    headers: {
      "X-Requested-With": `XMLHttpRequest`,
      Accept: `application/javascript`,
    },
  };
  let sectionId = "ajax-cart-drawer";
  let section = "";
  var baseUrl = window.location.pathname;
  if (baseUrl.indexOf("/cart") > -1) {
    let cartSection = document.querySelector("[data-cart-wrapper]");
    section = cartSection;
    if (cartSection) {
      sectionId = cartSection.dataset.section;
    }
  }
  const formData = new FormData(form);
  formData.append("sections", [sectionId]);

  const nfaFormValue = form.querySelector("#nfa-form-value");
  if (nfaFormValue && nfaFormValue.value !== "") {
    const jsonObject = JSON.parse(nfaFormValue.value);

    const extractedData = jsonObject.attributes.reduce((acc, attribute) => {
      const key = attribute.title;
      const value = attribute.value || attribute.optionName;
      const title = attributeMap[attribute.code];
      if (!title) {
        console.error(
          `Form attribute ${attribute.title}'s key is missing in the map. Go to cart.js and add it'`
        );
        title = attribute.title;
      }
      formData.append(`properties[_${title}]`, value);
    }, {});
  }

  //console.log(formData);
  config.body = formData;

  fetch(cartAddUrl, config)
    .then((response) => {
      //console.log(response);
      return response.text();
    })
    .then((responseText) => {
      const cart = JSON.parse(responseText);
      if (cart.status) {
        if (cart.errors) {
          let giftCardWrapper = formParent.querySelector(
            "[data-gift-card-box]"
          );
          if (giftCardWrapper && cart.errors["email"]) {
            let errormessageWrapper = giftCardWrapper.querySelector(
              "[data-gift-card-errors]"
            );
            let giftCardEmail = formParent.querySelector("[type=email]");
            let errorMessage =
              errormessageWrapper.querySelector(".error-message");
            errorMessage.innerHTML =
              giftCardEmail.dataset.attr + " " + cart.errors["email"];
            errormessageWrapper.classList.remove("hidden");
            //giftCardErrors
          }
        } else {
          Array.from(formParent.querySelectorAll("[data-form-error]")).forEach(
            function (errorContainer) {
              errorContainer.textContent = cart.description;
              errorContainer.classList.remove("hidden");
              // if (!isOnScreen(errorContainer)) {
              //     var scrollDiv = errorContainer.offsetTop;
              //     window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
              // }
            }
          );
        }
        element.removeAttribute("disabled");
        return false;
      }
      if (carType == "page") {
        window.location.href = "/cart";
        return false;
      }
      if (shakeEffect) {
        element.classList.add("shake");
        setTimeout(() => {
          element.classList.remove("shake");
        }, 700);
      }
      if (hapticFeedbackStatus) {
        const canVibrate = window.navigator.vibrate;
        if (canVibrate) window.navigator.vibrate(500);
      }
      if (document.getElementById("cartAlert")) {
        document.getElementById("cartAlert").play();
      }
      if (baseUrl.indexOf("/cart") > -1) {
        let updatedCartHtml = new DOMParser()
          .parseFromString(cart.sections[sectionId], "text/html")
          .querySelector(".shopify-section");
        let updatedCartContent = updatedCartHtml.querySelector(
          "[data-cart-wrapper]"
        );
        let cartCount = parseInt(
          updatedCartContent.getAttribute("data-item-count")
        );
        cartCountUpdate(cartCount);
        section.innerHTML = updatedCartHtml.innerHTML;
        element.removeAttribute("disabled");
        setTimeout(() => {
          if (cartCount > 0) {
            getQuantityElement(section);
            cartNoteUpdate(section);
            getCartItemRemoveElements(section);
            cartGiftWrapElement(section);
            cartTotalprice(section);
            shippingEstimates();
          }
        }, 500);
        var scrollDiv = section.offsetTop;
        window.scrollTo({ top: scrollDiv, behavior: "smooth" });
      } else {
        let updateCartHtml = new DOMParser()
          .parseFromString(cart.sections[sectionId], "text/html")
          .querySelector(".shopify-section");
        let updateCartContent = updateCartHtml.innerHTML;
        let cartBody = document.querySelector("[data-cart-drwaer-body]");
        let cartItemcount = 0;
        let cartItemtotalprice;
        if (updateCartHtml.querySelector("[data-cart-wrapper]")) {
          cartItemcount = parseInt(
            updateCartHtml
              .querySelector("[data-cart-wrapper]")
              .getAttribute("data-item-count")
          );
          cartItemtotalprice = updateCartHtml
            .querySelector("[data-cart-wrapper]")
            .getAttribute("data-item-total");
        }
        cartBody.innerHTML = updateCartContent;
        if (cartItemcount > 0) {
          getQuantityElement(cartBody);
        }
        cartCountUpdate(cartItemcount);
        cartNoteUpdate();
        // SidedrawerEventInit(cartDrawer);
        getCartItemRemoveElements(cartDrawer);
        cartGiftWrapElement(cartDrawer);
        cartTermhandlerClick();
        cartTermsHandler();

        setTimeout(function () {
          let Cartdrawer = document.querySelector(".cart-drawer");
          let Quickview = document.querySelector(".quickview-drawer");
          let Comparemodel = document.querySelector("[data-compare-model]");
          if (Quickview) {
            Quickview.classList.remove("sidebar-visible");
            setTimeout(function () {
              Quickview.style.display = "none";
            }, 300);
          }
          if (Comparemodel) {
            if (
              Cartdrawer.classList.contains("sidebar-visible") &&
              Comparemodel.querySelector(".compare-modal-content")
            ) {
              Comparemodel.querySelector(
                ".compare-modal-content"
              ).classList.remove("popup-visible");
            }
          }
        }, 100);
        setTimeout(function () {
          if (cartDrawer) {
            cartDrawer.classList.add("sidebar-visible");
          }
          setTimeout(function () {
            focusElementsRotation(cartDrawer);
            previousFocusElement = element;
          }, 500);
        }, 500);

        let recommendProducts = cartDrawer.querySelector(
          "[data-recommendation-popup]"
        );
        if (
          recommendProducts &&
          !recommendProducts.classList.contains("active")
        ) {
          setTimeout(() => {
            recommendProducts.classList.add("active");
          }, 1000);
          slideshowElements();
        }
        cartDrawer.style.display = "flex";
        //updateCartItems();
        document.querySelector("body").classList.add("no-scroll");
        element.removeAttribute("disabled");
      }
      if (
        document.querySelector("[data-cart-shipping]") &&
        document
          .querySelector("[data-cart-shipping]")
          .getAttribute("data-barwidth") == "100%"
      ) {
        if (
          document.querySelector(".confetti-container-wrapper") &&
          (localStorage.confettiEffect == "false" ||
            localStorage.confettiEffect == undefined)
        ) {
          window.confettiful = new Confettiful(
            document.querySelector(".confetti-container-wrapper")
          );
          localStorage.confettiEffect = "true";
          setTimeout(function () {
            clearInterval(confettiInterval);
          }, 3000);
        }
      }
    })
    .catch(function (err) {
      element.removeAttribute("disabled");
    });
}

function setJoiiQuickAdds() {
  var joiiQuickAdds = document.querySelectorAll(".joii-quick-add-vars");
  joiiQuickAdds.forEach((joiiQuickAdd) => {
    if (!joiiQuickAdd.classList.contains("js-ready")) {
      var qaIsActive = false;
      var quickAddVars = joiiQuickAdd.querySelectorAll(".joii-quick-add-var");
      quickAddVars.forEach((quickAddVar) => {
          quickAddVar.addEventListener("click", function (event) {
              var thisQAAdd = this.closest(".joii-quick-add-vars");
              var thisQAVars = this.closest(".joii-quick-add-var");
              var thisQASubmit = thisQAAdd.querySelector(".joii-quick-add-var-submit");
              thisQASubmit.style.display = "inline";
              var allQAVars = this.closest(".joii-quick-add-vars").querySelectorAll(".joii-quick-add-var");
              allQAVars.forEach((allQAVar) => {
                  allQAVar.classList.remove("active");
              });
              thisQASubmit.setAttribute("qa-var-id",this.getAttribute("var-id"));
              this.classList.add("active");
          });
          if (quickAddVar.classList.contains("active")) {
              qaIsActive = true
          }
          var joiiQuickAddSubmit = joiiQuickAdd.querySelector(".joii-quick-add-var-submit");
          if (qaIsActive) {
              joiiQuickAddSubmit.style.display = "inline";
          }
          if (!joiiQuickAddSubmit.classList.contains("qa-add-ready")) {
              joiiQuickAddSubmit.addEventListener("click", async function (event) {
                  var qaVarID = this.getAttribute("qa-var-id");
                  var qlfyTotal = this.getAttribute("qlfy-total");
                  try {
                  const response = await fetch('/cart/add.js', {
                      method: 'POST',
                      headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/json'
                      },
                      body: JSON.stringify({
                      id: qaVarID,
                      quantity: 1,
                      properties: {
                      "_FreeGift": qlfyTotal,
                      }
                      })
                  });

                  if (!response.ok) throw new Error('Error adding qa variant');

                  const data = await response.json();
                  //console.log('Added qa to cart:', data);
                  
                  // Optionally refresh cart UI
                  // location.reload();
                  } catch (err) {
                  console.error('Failed to add qa variant:', err);
                  }
                  this.closest(".joii-quick-add-vars").remove();
                  addToCartItems();
              });
              joiiQuickAddSubmit.classList.add("qa-add-ready");
          }
      });
      joiiQuickAdd.classList.add("js-ready");
    }
  });
}


//subscription (repeat) selling plan change
function changeCartSellingPlan(itemKey, oldSellingPlan, newSellingPlan, quantityInput) {
  // Get the current cart to find the item we want to update
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(cart => {
      let updates = {};

      //console.log("new ", newSellingPlan);
      //console.log("old ", oldSellingPlan);
      
      if (newSellingPlan !== oldSellingPlan) {
        updates = {
            'id': itemKey,
            'quantity': quantityInput,
            'selling_plan': newSellingPlan
          };
      }
      
      if (Object.keys(updates).length > 0) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(updates)
        });
      } else {
        throw new Error("No updates to send.");
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(cart => {
      //console.log("Selling plan updated successfully:", cart);
      //location.reload();
      addToCartItems();
      //addToCartElem();
    })
    .catch(error => {
      console.error('Error updating selling plan:', error);
    });
}



//Quantity change
function getQuantityElement(section = document) {
  let quantityElements = section.querySelectorAll("[data-quantity-wrapper]");
  Array.from(quantityElements).forEach(function (element) {
    initQuantityAction(element);
  });
}

function initQuantityAction(element) {
  if (element.classList.contains("qty-js-loaded")) return;
  element.classList.add("qty-js-loaded");

  //console.log("initQuantityAction");
  let quantityInput = element.querySelector("[data-quantity-input]");
  let quantityIncreament = element.querySelector("[data-quantity-increment]");
  let quantityDecreament = element.querySelector("[data-quantity-decrement]");
  if (quantityInput) {
    quantityInput.onkeydown = function (e) {
      if (
        !(
          (e.keyCode > 95 && e.keyCode < 106) ||
          (e.keyCode > 47 && e.keyCode < 58) ||
          e.keyCode == 8 ||
          e.keyCode == 9 ||
          (e.keyCode > 36 && e.keyCode < 41)
        )
      ) {
        return false;
      }
    };
    if (quantityInput.classList.contains("ajax-cart-update")) {
      quantityInput.addEventListener("change", function (event) {
        let currentValue = parseInt(quantityInput.value);
        let section = quantityInput.closest("[data-cart-wrapper]");
        let cartItem = quantityInput.closest("[data-cart-item]");
        cartItem.classList.add("disabled");
        //let line = quantityInput.dataset.line;
        let line = cartItem.getAttribute('line-item-index');
        changeCartItem(line, currentValue, section, cartItem);
      });
    }
  }
  quantityIncreamentDecreament(
    quantityIncreament,
    quantityDecreament,
    quantityInput
  );
}

function quantityIncreamentDecreament(
  quantityIncreament,
  quantityDecreament,
  quantityInput
) {
  if (quantityIncreament) {
    quantityIncreament.addEventListener("click", function (event) {
      event.preventDefault();
      quantityIncreament;
      let currentValue = parseInt(quantityInput.value);
      updatedValue = currentValue + 1;
      quantityInput.value = updatedValue;
      if (quantityIncreament.classList.contains("ajax-cart-update")) {
        quantityUpdate(quantityInput);
      }
    });
  }
  if (quantityDecreament) {
    quantityDecreament.addEventListener("click", function (event) {
      event.preventDefault();

      let currentValue = parseInt(quantityInput.value);
      updatedValue = currentValue - 1;
      if (updatedValue > 0) {
        quantityInput.value = updatedValue;
      }
      if (quantityDecreament.classList.contains("ajax-cart-update")) {
        quantityInput.value = updatedValue;
        quantityUpdate(quantityInput);
      }
    });
  }
}

function getCartItemRemoveElements(section = document) {
  let cartItemRemoveElements = section.querySelectorAll("[data-item-remove]");
  Array.from(cartItemRemoveElements).forEach(function (element) {
    initCartItemRemove(element);
    if (element) {
      cartTotalprice();
    }
  });
}

function cartGiftWrapElement(section = document) {
  let cartGiftWrap = section.querySelector("[data-gift-atc]");
  if (cartGiftWrap) {
    cartGiftWrap.addEventListener("click", (event) => {
      event.preventDefault();
      let formParent = cartGiftWrap.closest("[data-gift-card]");
      let form = formParent.querySelector("form");
      addItemtoCart(form, formParent, cartGiftWrap);
    });
  }
}

function initCartItemRemove(element) {
  element.addEventListener("click", (event) => {
    event.preventDefault();
    let section = element.closest("[data-cart-wrapper]");
    element.closest("[data-cart-item]").classList.add("disabled");
    //let line = element.dataset.line;
    var cartItem = element.closest('.cart-details-item');
    let line = cartItem.getAttribute('line-item-index');
    changeCartItem(line, 0, section, element.closest("[data-cart-item]"));
  });
}

function quantityUpdate(quantityInput) {
  let section = quantityInput.closest("[data-cart-wrapper]");
  let cartItem = quantityInput.closest("[data-cart-item]");
  cartItem.classList.add("disabled");
  let quantity = parseInt(quantityInput.value);
  //let line = quantityInput.dataset.line;
  let line = cartItem.getAttribute('line-item-index');
  if (quantity == 0) cartItem.classList.add("item-deleting");
  changeCartItem(line, quantity, section, cartItem);
}

function cartUpdateElems(curHtml, newHtml) {
  //console.log("cartUpdateElems");
  var curCart = curHtml.querySelector('.cart-wrapper');
  var newCart = newHtml.querySelector('.cart-wrapper');

  if (newCart.getAttribute("data-item-count") == "0") { // Empty Cart Page
    var curMain = curHtml.querySelector('main');
    var newMain = newHtml.querySelector('main');
    curMain.innerHTML = newMain.innerHTML;

  } else if (curCart.getAttribute("data-item-count") == "0" && newCart.getAttribute("data-item-count") != "0") { // Live Cart Page
    var curMain = curHtml.querySelector('main');
    var newMain = newHtml.querySelector('main');
    curMain.innerHTML = newMain.innerHTML;

  } else { // Update Cart

    // items
    const newItems = newCart.querySelectorAll('.cart-details-item');
    const oldItems = curCart.querySelectorAll(`.cart-details-item`);
    var cartFormWrapper = curCart.querySelector(`.cart-form-wrapper`);
    newItems.forEach((nIt, i) => {
      //console.log(`new item`);
      addToggleListeners(nIt);
      //console.log(nIt);
      //cartFormWrapper.insertBefore(nIt, cartFormWrapper.firstChild);
      cartFormWrapper.appendChild(nIt);
    });
    oldItems.forEach((oIt, i) => {
      oIt.remove();
    });

    // Promo Banners
    if (curCart.querySelector(".joii-basket-promos") && newCart.querySelector(".joii-basket-promos")) {
      curCart.querySelector(".joii-basket-promos").innerHTML = newCart.querySelector(".joii-basket-promos").innerHTML;
    }

    // Ship Gauge
    if (curCart.querySelector(".joii-free-shipping-gauge") && newCart.querySelector(".joii-free-shipping-gauge")) {
      curCart.querySelector(".joii-free-shipping-gauge").innerHTML = newCart.querySelector(".joii-free-shipping-gauge").innerHTML;
    }
    // Totals
    if (curCart.querySelector(".cart-subtotal-box") && newCart.querySelector(".cart-subtotal-box")) {
      curCart.querySelector(".cart-subtotal-box").innerHTML = newCart.querySelector(".cart-subtotal-box").innerHTML;
    }
    //
    // if (curCart.querySelector("[data-cart-form]") && newCart.querySelector("[data-cart-form]")) {
    //   curCart.querySelector("[data-cart-form]").innerHTML = newCart.querySelector("[data-cart-form]").innerHTML;
    // }
    //
    if (curCart.querySelector("[data-cart-item-count]") && newCart.querySelector("[data-cart-item-count]")) {
      curCart.querySelector("[data-cart-item-count]").innerHTML = newCart.querySelector("[data-cart-item-count]").innerHTML;
    }
    //
    if (curCart.querySelector("[data-cart-note-wrapper]") && newCart.querySelector("[data-cart-note-wrapper]")) {
      curCart.querySelector("[data-cart-note-wrapper]").innerHTML = newCart.querySelector("[data-cart-note-wrapper]").innerHTML;
    }
    // Old shipping
    // if (curCart.querySelector("[data-cart-shipping]") && newCart.querySelector("[data-cart-shipping]")) {
    //   // cartBody.querySelector('[data-cart-shipping]').innerHTML =  newCart.querySelector('[data-cart-shipping]').innerHTML;
    //   let delay = 0;
    //   if (
    //     !curCart
    //       .querySelector("[data-cart-shipping-bar]")
    //       .classList.contains("active")
    //   ) {
    //     curCart
    //       .querySelector("[data-cart-shipping-bar]")
    //       .classList.add("active");
    //     delay = 150;
    //   }
    //   curCart.querySelector("[data-cart-shipping-text]").textContent =
    //     newCart.querySelector("[data-cart-shipping-text]").textContent;
    //   setTimeout(function () {
    //     curCart
    //       .querySelector("[data-cart-shipping-bar]")
    //       .style.setProperty(
    //         "width",
    //         newCart.querySelector("[data-cart-shipping]").dataset
    //           .barwidth
    //       );
    //     if (curCart.querySelector("[data-cart-shipping-bar]").style.width == "100%") {
    //       setTimeout(function () {
    //         document
    //           .querySelector("[data-cart-shipping]")
    //           .classList.add("shipping-full");
    //         if (
    //           document.querySelector(".confetti-container-wrapper") &&
    //           (localStorage.confettiEffect == "false" ||
    //             localStorage.confettiEffect == undefined)
    //         ) {
    //           window.confettiful = new Confettiful(
    //             document.querySelector(".confetti-container-wrapper")
    //           );
    //           localStorage.confettiEffect = "true";
    //         }
    //         setTimeout(function () {
    //           clearInterval(confettiInterval);
    //         }, 3000);
    //       }, 100);
    //     } else {
    //       document
    //         .querySelector("[data-cart-shipping]")
    //         .classList.remove("shipping-full");
    //       localStorage.confettiEffect = "false";
    //       clearInterval(confettiInterval);
    //     }
    //   }, delay);
    // }

    //
    if (curCart.querySelector("[data-cart-prices]") && newCart.querySelector("[data-cart-prices]")) {
      curCart.querySelector("[data-cart-prices]").innerHTML = newCart.querySelector("[data-cart-prices]").innerHTML;
    }
    //
    if (curCart.querySelector("[data-gift-card]") && newCart.querySelector("[data-gift-card]")) {
      curCart.querySelector("[data-gift-card]").innerHTML = newCart.querySelector("[data-gift-card]").innerHTML;
    }


    
    setJoiiQuickAdds();

  }

}

function cartContentUpdate(cart, sectionId) {

  //updateCartItems();
  let updatedCartHtml = new DOMParser()
    .parseFromString(cart.sections[sectionId], "text/html")
    .querySelector(".shopify-section");
  let cartBody = document.querySelector("[data-cart-wrapper]");
  if (sectionId == "ajax-cart-drawer") {
    cartBody = document.querySelector("[data-cart-drwaer-body]");
  }
  if (cart.item_count > 0) {
    let cartCount = 0;
    cartCount = parseInt(
      updatedCartHtml
        .querySelector("[data-cart-wrapper]")
        .getAttribute("data-item-count")
    );
    cartCountUpdate(cartCount);
    //let cartTotalprice = cartBody.querySelector('[data-cart-wrapper]').getAttribute('data-item-total');
    //  cartTotalpriceUpdate(cartTotalprice);
    cartUpdateElems(document, updatedCartHtml);
    
    // 
    //
    if (sectionId != "ajax-cart-drawer") {
      shippingEstimates(cartBody);
    }
    getAllDetails(cartBody);
    getQuantityElement(cartBody);
    cartNoteUpdate(cartBody);
    getCartItemRemoveElements(cartBody);
    SidedrawerEventInit(cartBody);
    cartGiftWrapElement(cartBody);
  } else {
    localStorage.confettiEffect = "false";
    clearInterval(confettiInterval);
    if (sectionId == "ajax-cart-drawer") {
      let updateCartContent = updatedCartHtml.innerHTML;
      let cartBody = document.querySelector("[data-cart-drwaer-body]");
      cartBody.innerHTML = updateCartContent;
      SidedrawerEventInit(cartBody);
    } else {
      cartBody.innerHTML = updatedCartHtml.querySelector(
        "[data-cart-wrapper]"
      ).innerHTML;
    }
    let cartpriceSelector = document.querySelector("[data-header-cart-total]");
    let cartEmptyprice = document.querySelector("[data-cart-empty]");
    if (cartEmptyprice && cartpriceSelector) {
      cartpriceSelector.textContent = "";
      cartpriceSelector.classList.add("hidden");
    }
  }
}

function cartCountUpdate(itemCount) {
  let cartCountSelectors = document.querySelectorAll(
    "[data-header-cart-count]"
  );
  document
    .querySelector("[data-cart-wrapper]")
    .setAttribute("data-item-count", itemCount);
  Array.from(cartCountSelectors).forEach(function (cartCountSelector) {
    if (itemCount > 0) {
      if (itemCount > 99) {
        cartCountSelector.textContent = "";
        cartCountSelector
          .closest(".cart.header-icons-link")
          .classList.add("dot-icon");
      } else {
        cartCountSelector.textContent = itemCount;
        cartCountSelector
          .closest(".cart.header-icons-link")
          .classList.remove("dot-icon");
      }
      cartCountSelector.classList.remove("hidden");
    } else {
      cartCountSelector.textContent = "";
      cartCountSelector.classList.add("hidden");
    }
    // if (itemCount == 1) {
    //     let itemText = cartCountSelector.getAttribute('data-item-text');
    //     document.querySelector('.cart-item-text').textContent = itemText;
    // }
    // else
    // {
    //     let itemsText = cartCountSelector.getAttribute('data-items-text');
    //     document.querySelector('.cart-item-text').textContent = itemsText;
    // }
  });
}

function cartTotalprice(section = document) {
  let cartSection = section.querySelector("[data-cart-wrapper]");
  let cartpriceSelector = document.querySelector("[data-header-cart-total]");
  if (cartSection) {
    let cartPrice = section.querySelector(
      "[data-cart-prices] [data-cart-final-price]"
    ).textContent;
    cartSection.setAttribute("data-item-total", cartPrice);
    let cartSubtotalprice = cartSection.getAttribute("data-item-total");
    let cartQuantity = cartSection.getAttribute("data-item-count");
    if (cartQuantity > 0 && cartpriceSelector) {
      cartpriceSelector.textContent = cartSubtotalprice;
      cartpriceSelector.classList.remove("hidden");
    }
  }
}

function cartNoteUpdate() {
  let cartNoteElements = document.querySelectorAll("[data-cart-note]");
  var cartNoteTyping;
  Array.from(cartNoteElements).forEach(function (element) {
    element.addEventListener("keydown", (event) => {
      clearTimeout(cartNoteTyping);
    });
    element.addEventListener("keyup", (event) => {
      clearTimeout(cartNoteTyping);
      cartNoteTyping = setTimeout(function () {
        const body = JSON.stringify({
          note: element.value,
        });
        fetch(cartUpdateUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: `application/json`,
          },
          body,
        }).then((response) => {
          return response.text();
        });
      }, 1000);
    });
  });
}
/* Cart change item event start */

changeCartItem = function (line, quantity, section, cartItem) {
  let sectionId = section.dataset.section;
  let allErrorSelectors = section.querySelectorAll(".cart-item-error");
  Array.from(allErrorSelectors).forEach(function (errorSelector) {
    errorSelector.querySelector("[data-error-text]").innerHTML = "";
    errorSelector.style.display = "none";
  });
  const body = JSON.stringify({
    "id": line,
    "quantity": quantity,
    "sections": [sectionId],
  });
  //console.log(body);
  fetch(cartChangeUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/json` },
    body,
  })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const cart = JSON.parse(state);
      if (cart.status) {
        if (cartItem.querySelector(".cart-item-error")) {
          let quantityWrappers = cartItem.querySelectorAll(".quantity-input");
          cartItem.querySelector("[data-error-text]").innerHTML = cart.message;
          cartItem.querySelector(".cart-item-error").style.display = "block";
          Array.from(quantityWrappers).forEach(function (quantity) {
            quantity.value = quantity.getAttribute("data-previous-value");
          });
          cartItem.classList.remove("disabled");
        }
        return false;
      }
      // if (cart.item_count > 0) {
      // }
      //cartCountUpdate(cart.item_count);

      userCart = cart;
      //  cartTotalpriceUpdate(carTotalprice);
      if (cart.sections) {
        cartContentUpdate(cart, sectionId);
      }
      // cartNoteDrawerInt(section);
    });
};
/* Cart change item event end */
if (window.location.pathname.indexOf("/cart") > -1) {
  // Shipping Estimations
  (function () {
    function shippingEstimates() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        var country = document.getElementById("shippingCountry");

        if (!country) {
          return false;
        }
        var shipping = new Shopify.CountryProvinceSelector(
          "shippingCountry",
          "address_province",
          {
            hideElement: "shippingProvinceContainer",
          }
        );

        setupEventListeners();
      }
    }

    function setupEventListeners() {
      var button = document.getElementById("getShippingEstimates");
      if (button) {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          $("#shipping-wrapper-response")
            .html("")
            .removeClass("success")
            .removeClass("error")
            .hide();
          var shippingAddress = {};
          shippingAddress.zip = jQuery("#address_zip").val() || "";
          shippingAddress.country = jQuery("#shippingCountry").val() || "";
          shippingAddress.province = jQuery("#address_province").val() || "";
          _getCartShippingRates(shippingAddress);
        });
      }
    }

    var _getCartShippingRates = function (shippingAddress) {
      var params = {
        type: "POST",
        url: "/cart/shipping_rates.json",
        data: jQuery.param({ shipping_address: shippingAddress }),
        success: function (data) {
          _render(data.shipping_rates);
        },
        error: _onError,
      };
      jQuery.ajax(params);
    };

    var _fullMessagesFromErrors = function (errors) {
      var fullMessages = [];
      jQuery.each(errors, function (attribute, messages) {
        jQuery.each(messages, function (index, message) {
          fullMessages.push(message);
        });
      });
      return fullMessages;
    };
    var _onError = function (XMLHttpRequest, textStatus) {
      var data = eval("(" + XMLHttpRequest.responseText + ")");
      feedback = _fullMessagesFromErrors(data).join(", ") + ".";
      $("#shipping-wrapper-response")
        .html('<p class="error-text error">' + feedback + "</p>")
        .addClass("error")
        .show();
    };
    var _render = function (response) {
      if (response && response.length > 0) {
        var html = '<p class="success-text success">';
        response.forEach(function (shipping) {
          html += `<span><strong>${
            shipping.name
          }:</strong>${Shopify.formatMoney(
            shipping.price * 100,
            moneyFormat
          )}</span>`;
        });
        html += "</p>";
        $("#shipping-wrapper-response").html(html).addClass("success").show();
      } else {
        $("#shipping-wrapper-response")
          .html('<p class="error-text error">' + notAvailableLabel + "</p>")
          .addClass("error")
          .show();
      }
    };
    setTimeout(function () {
      shippingEstimates();
    }, 500);

    window.shippingEstimates = shippingEstimates;
  })();
  document.addEventListener("shopify:section:load", shippingEstimates, false);
}
